"use client";

import { useState } from "react";
import styles from "../../../styles/contact/contactForm.module.css";

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const validate = () => {
    let newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }
    
    if (!formData.mobile.trim()) {
      newErrors.mobile = "Mobile number is required";
    } else if (!/^\d{10}$/.test(formData.mobile)) {
      newErrors.mobile = "Mobile number must be 10 digits";
    }
    
    if (!formData.message.trim()) newErrors.message = "Message is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    
    setLoading(true);
    setStatus("");

    try {
      const response = await fetch("/api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus("success");
        setFormData({ name: "", email: "", mobile: "", message: "" });
      } else {
        setStatus("error");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setStatus("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}>Let's Connect</h2>
        <p className={styles.description}>
          Have a question or looking for the right molecular diagnostic solution? Our experts are ready to assist you with product information, technical guidance, partnership opportunities, and dedicated support. Reach out to Diagnomed—we're here to help you advance diagnostic excellence.        </p>
      </div>

      <div className={styles.content}>
        <div className={styles.leftColumn}>
          {/* Phone Card */}
          <div className={styles.contactCard}>
            <h3 className={styles.cardTitle}>Phone</h3>
            <div className={styles.contactItem}>
              <div className={styles.contactIcon}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <p className={styles.contactText}>+91 9625048157</p>
            </div>
            <div className={styles.contactItem}>
              <div className={styles.contactIcon}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <p className={styles.contactText}>+91 9717036057</p>
            </div>
          </div>

          {/* Email Card */}
          <div className={styles.contactCard}>
            <h3 className={styles.cardTitle}>Email</h3>
            <div className={styles.contactItem}>
              <div className={styles.contactIcon}>
                <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M22 6L12 13L2 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <p className={styles.contactText}>info@diagnomedindia.com</p>
            </div>
          </div>
        </div>

        {/* Form Container */}
        <form onSubmit={handleSubmit} className={styles.formContainer}>
          <div className={styles.formGroup}>
            <input type="text" name="name" placeholder="Name*" className={styles.input} aria-label="Name" value={formData.name} onChange={handleChange} />
            {errors.name && <span style={{ color: "red", fontSize: "0.8rem", marginTop: "4px", display: "block" }}>{errors.name}</span>}
          </div>
          <div className={styles.formGroup}>
            <input type="email" name="email" placeholder="Email*" className={styles.input} aria-label="Email" value={formData.email} onChange={handleChange} />
            {errors.email && <span style={{ color: "red", fontSize: "0.8rem", marginTop: "4px", display: "block" }}>{errors.email}</span>}
          </div>
          <div className={styles.formGroup}>
            <input type="tel" name="mobile" placeholder="Mobile Number*" className={styles.input} aria-label="Mobile Number" value={formData.mobile} onChange={handleChange} />
            {errors.mobile && <span style={{ color: "red", fontSize: "0.8rem", marginTop: "4px", display: "block" }}>{errors.mobile}</span>}
          </div>

          <div className={styles.formGroup}>
            <textarea name="message" placeholder="Message*" className={`${styles.input} ${styles.textarea}`} aria-label="Message" value={formData.message} onChange={handleChange}></textarea>
            {errors.message && <span style={{ color: "red", fontSize: "0.8rem", marginTop: "4px", display: "block" }}>{errors.message}</span>}
          </div>
          <button type="submit" className={styles.submitBtn} disabled={loading} style={{ opacity: loading ? 0.7 : 1 }}>
            {loading ? "Submitting..." : "Submit"}
          </button>
          {status === "success" && (
            <p style={{ color: "green", marginTop: "10px" }}>Message sent successfully!</p>
          )}
          {status === "error" && (
            <p style={{ color: "red", marginTop: "10px" }}>Failed to send message. Please try again.</p>
          )}
        </form>
      </div>
    </section>
  );
}
